/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListResourceRecommendationFilters extends models.RecommendationFilterBase {
    getFixupPrototypeFunction() { return ListResourceRecommendationFilters.fixupPrototype; }

    static newInstance(model: Partial<ListResourceRecommendationFilters>): ListResourceRecommendationFilters {
        let obj = Object.assign(new ListResourceRecommendationFilters(), model);
        ListResourceRecommendationFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListResourceRecommendationFilters>): ListResourceRecommendationFilters {
        if (!model) return null;
        return ListResourceRecommendationFilters.newInstance(<ListResourceRecommendationFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListResourceRecommendationFilters) {
        if (!obj) return;

        models.ListResourceRecommendationFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListResourceRecommendationFilters): boolean {
        if (models.RecommendationFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ListResourceRecommendationFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * List of recommendation IDs to get the resource recommendations.
     */
    recommendation_ids: Array<string>;

    /**
     * List of exclusion rule Ids to get resources to exclude.
     */
    rule_ids: Array<string>;

    /**
     * Search based on resource_id, resource_name, resource, resource category, resource type and region/location.
     */
    search: string;

    /**
     * Query based on Resource Group, Region, resource_id, resource_name and resource
     */
    filters: models.QueryOperator;

}
